interface ToggleProps {
  primaryOption: string;
  secondaryOption: string;
  isActive: boolean;
  onClick: () => void;
}

const Toggle = ({ isActive, onClick, primaryOption, secondaryOption }: ToggleProps) => {
  return (
    <div
      onClick={onClick}
      className="flex max-h-10 max-w-60 cursor-pointer rounded-3xl border border-primary border-opacity-45 bg-base-200 p-1 text-base font-normal"
    >
      <div
        className={`flex rounded-3xl px-6 py-1 transition duration-300 ease-in-out ${
          isActive ? 'bg-primary text-primary-content' : 'bg-base-200'
        }`}
      >
        {primaryOption}
      </div>
      <div
        className={`flex rounded-3xl px-6 py-1 transition duration-300 ease-in-out ${
          !isActive ? 'bg-primary text-primary-content' : 'bg-base-200'
        }`}
      >
        {secondaryOption}
      </div>
    </div>
  );
};

export default Toggle;
